import betwayLogo from "../../assets/betway-logo.png";
import styles from "./BetwayAccountFragment.module.css";
import { openExternalUrl, openExternalUrlAndroid } from "../../utils/externalUrlHandler";

const BetwayAccountFragment = () => {
	const handleOpenBetwayAccount = () => {
		// Check if Android WebView is available first
		if (window.Android && typeof window.Android.openExternal === "function") {
			// Android WebView - only call Android function
			openExternalUrlAndroid();
		} else {
			// iOS WebView or regular browser - call iOS function (with fallback)
			openExternalUrl();
		}
	};

	return (
		<div className={styles.container}>
			<div className={styles.card}>
				<div className={styles.logoContainer}>
					<img src={betwayLogo} alt="Betway" className={styles.logo} />
				</div>

				<h2 className={styles.title}>Open a Betway Account</h2>

				<div className={styles.content}>
					<p className={styles.description}>
						You do not need to have a Betway account to play BW Fantasy Football, however to redeem a weekly cash prize for coming in the
						Top 10 in any week or a cash prize for coming in the Top 50 overall, you need to have a Betway account for those winnings to
						be deposited into.
					</p>

					<p className={styles.rulesText}>See the Rules and Ts & Cs of the game for details of the weekly and overall cash prizes.</p>
				</div>

				<div className={styles.buttonContainer}>
					<button className={styles.openAccountButton} onClick={handleOpenBetwayAccount}>
						Open a Betway Account
					</button>
				</div>
			</div>
		</div>
	);
};

export default BetwayAccountFragment;
